import styled from 'styled-components';

import {
  BodyCopy as InnerBodyCopy,
  Headline as InnerHeadline,
} from '@xing-com/typography';

import InnerBaseButton from '../../components/base-button';

export const EmptyStateCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: var(--spaceXXL) 0 var(--spaceXXL) 0;
  background-color: var(--xdlColorBackgroundSecondary);
  height: 240px;
  @media (min-width: 740px) {
    height: 300px;
  }
`;

export const TextLayer = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--spaceXXL) var(--spaceXL);
`;

export const Headline = styled(InnerHeadline)`
  color: var(--xdlColorTextSecondary);
  margin-right: var(--spaceL);
`;

export const BodyCopy = styled(InnerBodyCopy)`
  color: var(--xdlColorTextSecondary);
  margin-right: var(--spaceL);
`;

export const BaseButton = styled(InnerBaseButton)`
  padding: var(--spaceL);
`;

export const Image = styled.img`
  display: none;
  @media (min-width: 740px) {
    display: flex;
  }
`;
